module.exports = __webpack_public_path__ + "img/Logo-martinez-vertical-blanco.683e1b5f.png";